var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deck-container"},[_c('div',{ref:"map",attrs:{"id":"map"}}),_c('canvas',{ref:"canvas",attrs:{"id":"deck-canvas"},on:{"contextmenu":function($event){$event.preventDefault();return (function () {
        return false;
      })($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }